export const API_BASE_URL = 'https://urbanmartapi-bqdwczd9gqcrdkc7.eastus-01.azurewebsites.net';
// export const API_BASE_URL = 'https://localhost:5001';